import { useCallback, useRef } from "react";

/**
 * Skip-to-content : lien d'accessibilité standard, invisible jusqu'au focus
 * clavier. Permet de sauter directement vers le <main id="main"> sans
 * traverser la topbar à chaque page. WCAG 2.1 — 2.4.1 Bypass Blocks.
 */
export function SkipToContent() {
  const ref = useRef<HTMLAnchorElement>(null);

  const jumpToMain = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault();
    const main = document.getElementById("main");
    if (!main) return;
    main.scrollIntoView({ behavior: "auto", block: "start" });
    main.focus({ preventScroll: true });
  }, []);

  return (
    <a
      ref={ref}
      href="#main"
      className="skip-to-content"
      onClick={jumpToMain}
      onKeyDown={(e) => {
        if (e.key === "Enter") jumpToMain(e);
      }}
      style={{
        position: "fixed",
        top: 0,
        left: "50%",
        zIndex: 9999,
        backgroundColor: "var(--charcoal)",
        color: "var(--ivory)",
        padding: "12px 24px",
        fontFamily: '"DM Mono", monospace',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: "2px",
        textTransform: "uppercase",
        textDecoration: "none",
        border: "1px solid var(--accent-cramoisi)",
      }}
    >
      Aller au contenu principal
    </a>
  );
}
